export default __webpack_public_path__ + "static/media/iconBed.93f8e0a9.svg";